<template>
  <div class="product">
    <div class="mt-5 pt-3">
      <h1>Voucher Catalog</h1>
    </div>
    <v-container>
      <ProductList />
    </v-container>
  </div>
</template>

<script>
import ProductList from '@/components/v2/ProductList'

export default {
  name: 'Product',
  components: {
    ProductList
  }
}
</script>

<style>
.product .v-tabs__div .v-tabs__item--active {
  background: green!important;
}

.product .v-tabs__item--active i.theme--light.v-icon {
  color: white!important;
}
</style>
